<template>
    <div class="md:hidden bg-gray-100 dark:bg-gray-900/30 rounded-lg py-4 px-2">
        <div class="flex flex-col gap-2">
            <div class="inline-flex items-center shrink-0 gap-2 ">
                <Icon name="folder" type="outline" />
                <span class="font-bold flex flex-col">

                    <span>{{ contract.nombre.toUpperCase() }}</span>
                </span>
            </div>

            <div v-if="contracts.length > 1">
                <nav class="flex flex-col" v-for="contra in contracts">
                    <div v-if="contra.id != contract.id">
                        <hr class="h-1 bg-gray-300">
                        <button type="button" @click="attemptSend(contra.id)" class="block w-full py-2 px-2 text-gray-600 dark:text-gray-400 hover:opacity-50 text-left" >
                            {{ contra.name.toUpperCase() }}
                        </button>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits } from 'vue';

    const emit = defineEmits(['attempt']);

    const props = defineProps({
        contract: Object,
        contracts: Array,
    });

    const attemptSend = (id) => {
        emit('attempt', { id});
    };
</script>
